import {
  useState, useEffect, useCallback, useRef,
} from "react";

const COOLDOWN_DURATION_SECONDS = 30;

export const useOtpResendCooldown = () => {
  const [remainingSeconds, setRemainingSeconds] = useState(COOLDOWN_DURATION_SECONDS);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const isOnCooldown = remainingSeconds > 0;

  const clearCooldownInterval = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  const startCooldown = useCallback(() => {
    clearCooldownInterval();
    setRemainingSeconds(COOLDOWN_DURATION_SECONDS);

    intervalRef.current = setInterval(() => {
      setRemainingSeconds((previous) => {
        if (previous <= 1) {
          clearCooldownInterval();
          return 0;
        }
        return previous - 1;
      });
    }, 1_000);
  }, []);

  useEffect(() => {
    startCooldown();
    return clearCooldownInterval;
  }, [startCooldown]);

  return { remainingSeconds, isOnCooldown, startCooldown };
};
